import { useMemo } from 'react';
import ViewContainerDecorator from 'documents-lib/js/decorators/ViewContainerDecorator';
import ViewContainer from 'documents-lib/js/containers/ViewContainer';
import { FloatingAlertList } from 'foundations-components/transitional/components/FloatingAlertList';
import * as DocumentsPublicActions from '../actions/DocumentsPublicActions';
import * as PublicViewerActions from '../actions/PublicViewerActions';
import { isChirpEnabled } from 'documents-lib/js/utils/isChirpEnabled';
import { useRequiresViewerInfo, useRequiresViewerInfoCHIRP } from '../hooks/useRequiresViewerInfo';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ViewComponent = ViewContainerDecorator(ViewContainer, {
  isPreview: false,
  documentActions: DocumentsPublicActions,
  hasHigherDocumentsLimit: undefined,
  publicViewerActions: PublicViewerActions
});
const getMatch = () => {
  var _searchParams$get;
  let presentationId = 0;
  const matchResult = window.location.pathname.match(/\/documents\/\d+\/view\/(\d+)/);
  if (matchResult) {
    const [__string, _presentationId] = matchResult;
    presentationId = Number(_presentationId);
  }
  const searchParams = new URLSearchParams(window.location.search);
  const accessId = (_searchParams$get = searchParams.get('accessId')) !== null && _searchParams$get !== void 0 ? _searchParams$get : undefined;

  // Mimic how Router sets up params
  return {
    params: {
      presentationId,
      accessId
    }
  };
};
export const ViewApplication = () => {
  const match = useMemo(() => getMatch(), []);
  const requiresViewerInfoREST = useRequiresViewerInfo();
  const requiresViewerInfoCHIRP = useRequiresViewerInfoCHIRP();
  const requiresViewerInfo = isChirpEnabled() ? requiresViewerInfoCHIRP : requiresViewerInfoREST;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ViewComponent, {
      match: match,
      requiresViewerInfo: requiresViewerInfo
    }), /*#__PURE__*/_jsx(FloatingAlertList, {})]
  });
};